import { render, staticRenderFns } from "./EverydayData.vue?vue&type=template&id=08828de4&scoped=true"
import script from "./EverydayData.vue?vue&type=script&lang=js"
export * from "./EverydayData.vue?vue&type=script&lang=js"
import style0 from "./EverydayData.vue?vue&type=style&index=0&id=08828de4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08828de4",
  null
  
)

export default component.exports